import _toConsumableArray from "C:/Users/gilbe/OneDrive/Documents/GitHub/luth-main/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useRef } from 'react';
import { Transition, TransitionGroup } from 'react-transition-group';
import { getDefaultZIndex, Portal, Box } from '@mantine/core';
import { useForceUpdate, useReducedMotion, useDidUpdate } from '@mantine/hooks';
import { NotificationsContext } from '../Notifications.context.js';
import { useNotificationsEvents } from '../events.js';
import getPositionStyles from './get-position-styles/get-position-styles.js';
import getNotificationStateStyles from './get-notification-state-styles/get-notification-state-styles.js';
import NotificationContainer from '../NotificationContainer/NotificationContainer.js';
import useStyles from './NotificationsProvider.styles.js';
import useNotificationsState from './use-notifications-state/use-notifications-state.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var POSITIONS = ["top-left", "top-right", "top-center", "bottom-left", "bottom-right", "bottom-center"];

function NotificationsProvider(_a) {
  var _b = _a,
      className = _b.className,
      _b$position = _b.position,
      position = _b$position === void 0 ? "bottom-right" : _b$position,
      _b$autoClose = _b.autoClose,
      autoClose = _b$autoClose === void 0 ? 4e3 : _b$autoClose,
      _b$transitionDuration = _b.transitionDuration,
      transitionDuration = _b$transitionDuration === void 0 ? 250 : _b$transitionDuration,
      _b$containerWidth = _b.containerWidth,
      containerWidth = _b$containerWidth === void 0 ? 440 : _b$containerWidth,
      _b$notificationMaxHei = _b.notificationMaxHeight,
      notificationMaxHeight = _b$notificationMaxHei === void 0 ? 200 : _b$notificationMaxHei,
      _b$limit = _b.limit,
      limit = _b$limit === void 0 ? 5 : _b$limit,
      _b$zIndex = _b.zIndex,
      zIndex = _b$zIndex === void 0 ? getDefaultZIndex("overlay") : _b$zIndex,
      style = _b.style,
      children = _b.children,
      others = __objRest(_b, ["className", "position", "autoClose", "transitionDuration", "containerWidth", "notificationMaxHeight", "limit", "zIndex", "style", "children"]);

  var forceUpdate = useForceUpdate();
  var refs = useRef({});
  var previousLength = useRef(0);

  var _useNotificationsStat = useNotificationsState({
    limit: limit
  }),
      notifications = _useNotificationsStat.notifications,
      queue = _useNotificationsStat.queue,
      showNotification = _useNotificationsStat.showNotification,
      updateNotification = _useNotificationsStat.updateNotification,
      hideNotification = _useNotificationsStat.hideNotification,
      clean = _useNotificationsStat.clean,
      cleanQueue = _useNotificationsStat.cleanQueue;

  var reduceMotion = useReducedMotion();
  var duration = reduceMotion ? 1 : transitionDuration;

  var _useStyles = useStyles(),
      classes = _useStyles.classes,
      cx = _useStyles.cx,
      theme = _useStyles.theme;

  var positioning = (POSITIONS.includes(position) ? position : "bottom-right").split("-");
  var ctx = {
    notifications: notifications,
    queue: queue,
    showNotification: showNotification,
    hideNotification: hideNotification,
    updateNotification: updateNotification,
    clean: clean,
    cleanQueue: cleanQueue
  };
  useDidUpdate(function () {
    if (notifications.length > previousLength.current) {
      setTimeout(function () {
        return forceUpdate();
      }, 0);
    }

    previousLength.current = notifications.length;
  }, [notifications]);
  useNotificationsEvents(ctx);
  var items = notifications.map(function (notification) {
    return /* @__PURE__ */React.createElement(Transition, {
      key: notification.id,
      timeout: duration,
      onEnter: function onEnter() {
        return refs.current[notification.id].offsetHeight;
      },
      nodeRef: {
        current: refs.current[notification.id]
      }
    }, function (state) {
      return /* @__PURE__ */React.createElement(NotificationContainer, {
        innerRef: function innerRef(node) {
          refs.current[notification.id] = node;
        },
        notification: notification,
        onHide: hideNotification,
        className: classes.notification,
        autoClose: autoClose,
        sx: [__spreadValues({}, getNotificationStateStyles({
          state: state,
          positioning: positioning,
          transitionDuration: duration,
          maxHeight: notificationMaxHeight
        }))].concat(_toConsumableArray(Array.isArray(notification.sx) ? notification.sx : [notification.sx]))
      });
    });
  });
  return /* @__PURE__ */React.createElement(NotificationsContext.Provider, {
    value: ctx
  }, /* @__PURE__ */React.createElement(Portal, {
    zIndex: zIndex
  }, /* @__PURE__ */React.createElement(Box, __spreadValues({
    className: cx(classes.notifications, className),
    style: style,
    sx: __spreadValues({
      maxWidth: containerWidth
    }, getPositionStyles(positioning, containerWidth, theme.spacing.md))
  }, others), /* @__PURE__ */React.createElement(TransitionGroup, null, items))), children);
}

NotificationsProvider.displayName = "@mantine/notifications/NotificationsProvider";
export { NotificationsProvider };